(() => {
  if (window.boxzyProductPageReady) return;
  window.boxzyProductPageReady = true;
  let scheduled = false;
  let opener;
  const cache = new WeakMap();
  const read = node => {
    if (!node) return {};
    if (!cache.has(node)) { try { cache.set(node, JSON.parse(node.textContent)); } catch { cache.set(node, {}); } }
    return cache.get(node);
  };
  const text = (node, value) => { if (node && node.textContent !== String(value ?? '')) node.textContent = value ?? ''; };
  const value = (node, next) => { if (node && node.value !== String(next ?? '')) node.value = next ?? ''; };
  const state = root => {
    const data = read(root.querySelector('[data-boxzy-pdp-data]'));
    const variants = data.variants || [];
    const radios = [...root.querySelectorAll('.swatches__form--input:checked')].sort((a,b) => Number(a.dataset.position) - Number(b.dataset.position));
    const selects = [...root.querySelectorAll('select.js-variant-selector')];
    const selected = radios.length ? radios.map(input => input.value) : selects.map(input => input.value);
    const id = root.querySelector('.product__form-buttons input[name="id"]')?.value;
    const variant = selected.length ? variants.find(item => item.options?.every((option,index) => String(option) === selected[index])) : variants.find(item => String(item.id) === id) || variants[0];
    return {data, variant};
  };
  const syncQuantity = root => {
    const field = root.querySelector('.js-qty-input');
    const next = Math.max(1, Math.floor(Number(field?.value) || 1));
    root.querySelectorAll('.product__form-buttons input[name="quantity"]').forEach(input => value(input,next));
    if (field) { field.inputMode = 'numeric'; if (!field.hasAttribute('aria-label') && field.labels?.[0]) field.setAttribute('aria-label',field.labels[0].textContent.trim()); }
  };
  const sync = root => {
    const {data, variant} = state(root);
    if (!data.labels) return;
    const labels = data.labels;
    const available = Boolean(variant?.available);
    if (variant?.compare_at_price > variant?.price && labels.savings) {
      const percent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency:data.currency || 'GBP'}).format((variant.compare_at_price - variant.price) / 100);
      text(root.querySelector('#product-price .sale-item--percentage'),labels.savings.replace('__SAVINGS__',percent));
      text(root.querySelector('#product-price .sale-item--amount'),labels.savings.replace('__SAVINGS__',amount));
    }
    text(root.querySelector('[data-boxzy-stock-label]'), !variant ? labels.unavailable : available ? data.preorder ? labels.preorder : labels.available : labels.soldOut);
    const stock = root.querySelector('[data-boxzy-stock]');
    if (stock && stock.dataset.available !== String(available)) stock.dataset.available = String(available);
    const optionLabels = data.optionLabels || {};
    const rawSelection = variant?.public_title || (variant?.title === 'Default Title' ? '' : variant?.title) || '';
    const selection = rawSelection ? (variant?.options || [rawSelection]).map(option => optionLabels[option] || option).join(' / ') : '';
    root.querySelectorAll('.swatches__option-value').forEach((node,index) => text(node,optionLabels[variant?.options?.[index]] || variant?.options?.[index] || ''));
    root.querySelectorAll('[data-boxzy-selection]').forEach(node => text(node,selection));
    const note = data.variantNotes?.[String(variant?.id)] || '';
    root.querySelectorAll('[data-boxzy-variant-note],[data-boxzy-contents]').forEach(node => { text(node,note); node.hidden = !note; });
    root.querySelectorAll('[data-boxzy-sku]').forEach(node => text(node,variant?.sku));
    root.querySelectorAll('[data-boxzy-restock]').forEach(node => { node.hidden = available || !variant; });
    root.querySelectorAll('[data-boxzy-enquiry-variant]').forEach(node => value(node,selection));
    root.querySelectorAll('[data-boxzy-enquiry-variant-id]').forEach(node => value(node,variant?.id));
    text(root.querySelector('[data-boxzy-enquiry-selection]'),selection ? `— ${selection}` : '');
    const sticky = root.querySelector('[data-boxzy-mobile-buy]');
    if (sticky) {
      if (variant) text(sticky.querySelector('[data-boxzy-mobile-price]'),new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency:data.currency || 'GBP'}).format(variant.price / 100));
      text(sticky.querySelector('[data-boxzy-mobile-selection]'),selection);
      const button = sticky.querySelector('button');
      text(button,available ? root.querySelector('.product__form-buttons .js-ajax-submit')?.textContent.trim() || labels.add : root.querySelector('[data-boxzy-restock]')?.textContent.trim() || labels.soldOut);
      if (button.disabled !== !variant) button.disabled = !variant;
      const mainButton = root.querySelector('.product__form-buttons .js-ajax-submit');
      sticky.hidden = !(window.matchMedia('(max-width: 740px)').matches && mainButton?.getBoundingClientRect().bottom < 0 && !document.querySelector('dialog[open]'));
    }
    const cells = [...root.querySelectorAll('.js-main-carousel-cell')].filter(cell => !cell.classList.contains('is-group-hidden'));
    if (cells.length) {
      const index = Math.max(0,cells.findIndex(cell => cell.classList.contains('is-selected'))) + 1;
      text(root.querySelector('[data-boxzy-gallery-counter]'),labels.photo.replace('__CURRENT__',index).replace('__TOTAL__',cells.length));
    }
    root.querySelectorAll('.js-thumb-item').forEach((node,index) => {
      if (!node.hasAttribute('role')) { node.setAttribute('role','button'); node.setAttribute('aria-label',labels.photo.replace('__CURRENT__',index + 1).replace('__TOTAL__',cells.length)); }
    });
    syncQuantity(root);
    const result = root.querySelector('[data-boxzy-enquiry-result]');
    const dialog = root.querySelector('[data-boxzy-enquiry-dialog]');
    if (result && dialog && !dialog.dataset.resultShown) { dialog.dataset.resultShown = 'true'; dialog.showModal(); }
  };
  const refresh = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; document.querySelectorAll('.boxzy-pdp').forEach(sync); });
  };
  const openEnquiry = (root,type,trigger) => {
    const dialog = root.querySelector('[data-boxzy-enquiry-dialog]');
    if (!dialog) return;
    const labels = read(root.querySelector('[data-boxzy-enquiry-labels]'));
    text(dialog.querySelector('[data-boxzy-enquiry-heading]'),labels[type] || labels.question);
    text(dialog.querySelector('[data-boxzy-enquiry-intro]'),labels[type + 'Intro'] || labels.questionIntro);
    value(dialog.querySelector('[data-boxzy-enquiry-type]'),type === 'review' ? 'Product review' : type === 'restock' ? 'Restock update request' : 'Product question');
    const review = type === 'review';
    const rating = dialog.querySelector('[data-boxzy-review-rating]');
    const consent = dialog.querySelector('[data-boxzy-review-consent-input]');
    [rating,consent].filter(Boolean).forEach(input => { input.disabled = !review; input.required = review; });
    dialog.querySelectorAll('[data-boxzy-review-fields],[data-boxzy-review-consent]').forEach(node => { node.hidden = !review; });
    const message = dialog.querySelector('[data-boxzy-enquiry-message]');
    if (message) message.required = type !== 'restock';
    opener = trigger;
    dialog.showModal();
    refresh();
  };
  document.addEventListener('click',event => {
    const root = event.target.closest('.boxzy-pdp');
    if (!root) return;
    const enquiry = event.target.closest('[data-boxzy-enquiry]');
    if (enquiry) { event.preventDefault(); openEnquiry(root,enquiry.dataset.boxzyEnquiry,enquiry); return; }
    if (event.target.closest('[data-boxzy-enquiry-close]')) { root.querySelector('[data-boxzy-enquiry-dialog]')?.close(); opener?.focus(); refresh(); return; }
    if (event.target.closest('[data-boxzy-mobile-add]')) {
      const {variant} = state(root);
      if (variant?.available) root.querySelector('.product__form-buttons .js-ajax-submit')?.click();
      else openEnquiry(root,'restock',event.target);
      return;
    }
    const dialog = event.target.closest('[data-boxzy-enquiry-dialog]');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) { dialog.close(); refresh(); }
    }
    refresh();
  },true);
  document.addEventListener('change',event => { if (event.target.closest('.boxzy-pdp')) { refresh(); setTimeout(refresh,350); } },true);
  document.addEventListener('input',event => { const root = event.target.closest('.boxzy-pdp'); if (root) syncQuantity(root); },true);
  document.addEventListener('submit',event => {
    const form = event.target.closest('.product__form-buttons');
    if (!form) return;
    const root = form.closest('.boxzy-pdp');
    if (!root) return;
    syncQuantity(root);
    const {variant} = state(root);
    if (variant) value(form.querySelector('input[name="id"]'),variant.id);
  },true);
  document.addEventListener('keydown',event => { const thumb = event.target.closest('.boxzy-pdp .js-thumb-item'); if (thumb && ['Enter',' '].includes(event.key)) { event.preventDefault(); thumb.click(); } });
  document.addEventListener('close',refresh,true);
  document.addEventListener('shopify:section:load',refresh);
  window.addEventListener('scroll',refresh,{passive:true});
  window.addEventListener('resize',refresh,{passive:true});
  new MutationObserver(refresh).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','disabled','value']});
  refresh();
})();

